import Link from "next/link";
import Image from "next/image";
import { usePathname } from "next/navigation";

type ToolLink = {
  href: string;
  label: string;
  icon: string;
};

const ToolTabs = ({
  links,
  layout,
}: {
  links: ToolLink[];
  layout: "row" | "column";
}) => {
  const pathname = usePathname();

  return (
    <div
      className={`flex ${layout === "row"
        ? "flex-nowrap gap-2 overflow-x-auto md:flex-wrap md:justify-center md:overflow-x-visible"
        : "flex-col gap-2"
        } scrollbar-hide mb-3`}
      style={
        layout === "row"
          ? {
            scrollbarWidth: "none",
            msOverflowStyle: "none",
          }
          : undefined
      }
    >
      {links.map(({ href, label, icon }) => {
        const isActive = pathname === href;
        return (
          <Link
            key={href}
            href={href}
            className={`flex ${layout === "row"
              ? "w-fit flex-shrink-0 flex-row"
              : "w-[100px] flex-col"
              } cursor-pointer items-center gap-2 rounded-[12px] px-2 py-2 text-[13px] font-normal text-[#202020] duration-300 ease-in-out sm:px-4 sm:py-3 md:text-[14px] xl:px-6 ${isActive
                ? "bg-[#F6F8FF]"
                : "bg-transparent hover:bg-[#F6F8FF]"
              }`}
          >
            <Image
              src={icon}
              alt={label}
              className="h-4 w-4 md:h-6 md:w-6"
              quality={100}
              priority
            />
            <span className={`${isActive ? "bg-gradient-to-r from-[#781E8F] to-[#422CBB] bg-clip-text text-transparent" : "text-[#8c8c8c]"} text-center`}>{label}</span>
          </Link>
        );
      })}
    </div>
  );
};

export default ToolTabs;
